import { createSlice, createAction } from '@reduxjs/toolkit';
import initialState from '../../../domain/app/ui/loaders';

// ------- SAGA ------ //

function changeStatusLoader(state, action) {
  const { isLoading } = action.payload;
  state.isLoaderGeneralApp = isLoading;
}

function changeStatusLoaderValidarCoordenadas(state, action) {
  const { isLoading } = action.payload;
  state.isLoaderGeneralApp = isLoading;
}

function changeStatusLoaderValidar(state, action) {
  const { isLoading } = action.payload;
  state.loaderValidar = isLoading;
}

function changeStatusLoaderValidarTcoo(state, action) {
  const { isLoading } = action.payload;
  state.loaderValidarTcco = isLoading;
}

function changeStatusLoaderSesion(state, action) {
  const { isLoading } = action.payload;
  state.loaderSesion = isLoading;
}

function changeStatusLoaderInformar(state, action) {
  const { isLoading } = action.payload;
  state.loaderInformar = isLoading;
}

function changeStatusObtener(state, action) {
  const { isLoading } = action.payload;
  state.loaderObtener = isLoading;
}

function changeStatusLoaderTercerFactorSolicitar(state, action) {
  const { isLoading } = action.payload;
  state.loaderTercerFactorSolicitar = isLoading;
}

function changeStatusLoaderTercerFactorValidar(state, action) {
  const { isLoading } = action.payload;
  state.loaderTercerFactorValidar = isLoading;
}

const loaderGeneral = createAction('loaderGeneral');


const loadersReducer = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    changeStatusLoader,
    changeStatusLoaderValidarCoordenadas,
    changeStatusLoaderValidar,
    changeStatusLoaderValidarTcoo,
    changeStatusLoaderSesion,
    changeStatusLoaderInformar,
    changeStatusObtener,
    changeStatusLoaderTercerFactorSolicitar,
    changeStatusLoaderTercerFactorValidar
  },
});

export const loadersActions = {
  ...loadersReducer.actions,
  loaderGeneral
};

export default loadersReducer.reducer;
